import { render, staticRenderFns } from "./ReNewSectionContent.vue?vue&type=template&id=297b501c"
import script from "./ReNewSectionContent.vue?vue&type=script&lang=js"
export * from "./ReNewSectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports